<template>
    <div>
        <div id="map-responsive" class="google-map" ref="googleMap" :style="{'padding-bottom': scale + '%'}"></div>
    </div>
</template>

<script>
    import { Loader } from '@googlemaps/js-api-loader';
    import $ from "jquery";
    import {Const, Global} from "@/main";

    var app

    export default {
        name: "GoogleMapLoader",
        props: {
            clickable: {
                type: Boolean,
                required: false,
                default: true
            },
            draggable: {
                type: Boolean,
                required: false,
                default: false
            },
            autocomplete: {
                required: false
            },
            positionX: {
                type: Number,
                required: false,
                default: 52.305571
            },
            positionY: {
                type: Number,
                required: false,
                default: 21.014535
            },
            scale: {
                type: Number,
                required: false,
                default: 71
            },
            zoom: {
                type: Number,
                required: false,
                default: 13
            }
        },
        data() {
            return {
                apiKey: Const.GOOGLE_MAPS_KEY,
                google: null,
                map: null,
                marker: null,
                infowindow: null,
                region: this.$i18n.locale.toUpperCase(),
                locale: this.$i18n.locale
            }
        },
        async mounted() {
            app = this

            const googleMapApi = new Loader({
                apiKey: this.apiKey,
                libraries: ['places'],
                language: this.locale
            })

            googleMapApi.load().then((loadedApi) => {
                this.google = loadedApi
                  app.initializeMap()
                }
            )

            if (this.$props.clickable) {
                setTimeout(function () {
                    updateContent($('#mt-contact-section .col-12 .row .col-9').html());
                    updatePosition($('#mt-contact-section .col-12 .row .d-none').html());

                    $('#mt-contact-section .col-12 .row').each(function () {
                        $(this).on("click", function () {
                            updateContent($(':nth-child(2)', this).html());
                            updatePosition($(':nth-child(2) .d-none', this).html());
                        });
                    });
                    Global.WIN_INFO.open(Global.MAP, Global.MARKER);
                }, 500);
            }
        },
        methods: {
            initializeMap() {
                var location = {
                  lat: this.positionX,
                  lng: this.positionY
                };
                var mapOptions = {
                    center: location,
                    zoom: this.zoom,
                    mapTypeId: 'roadmap'
                };
                const mapContainer = this.$refs.googleMap
                Global.MAP = new this.google.maps.Map(mapContainer, mapOptions)

                var markerImage = '/assets/mt-location.png';
                Global.MARKER = new this.google.maps.Marker({
                    position: location,
                    draggable: this.draggable,
                    map: Global.MAP,
                    icon: markerImage
                });

                this.google.maps.event.addListener(Global.MARKER, 'dragend',
                    function(marker) {
                        app.geocodePosition(marker.latLng);
                    }
                );

                Global.WIN_INFO = new this.google.maps.InfoWindow({
                    content: ''
                });

                if (this.$props.clickable) {
                    Global.MARKER.addListener('click', function () {
                        Global.WIN_INFO.open(Global.MAP, Global.MARKER);
                    });
                }

                var styles = [
                    {
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f5f5f5"
                            }
                        ]
                    },
                    {
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#616161"
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "color": "#f5f5f5"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.land_parcel",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.land_parcel",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#bdbdbd"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.neighborhood",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#eeeeee"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "labels.text",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#757575"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.business",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#e5e5e5"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#9e9e9e"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#757575"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#dadada"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#616161"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#9e9e9e"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "transit.line",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#e5e5e5"
                            }
                        ]
                    },
                    {
                        "featureType": "transit.station",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#eeeeee"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#c9c9c9"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "labels.text",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#9e9e9e"
                            }
                        ]
                    }
                ];
                Global.MAP.set('styles', styles);
            },
            geocodePosition(pos) {
                if (!this.autocomplete)
                    return

                var geocoder = new this.google.maps.Geocoder();
                geocoder.geocode({latLng: pos}, function(results, status) {
                    if (status === 'OK') {
                        app.autocomplete.$refs.autocomplete.value = results[0].formatted_address
                        app.autocomplete.$emit('placechanged')
                    }
                });
            }
        }
    }

    function updateContent(content) {
        Global.WIN_INFO.setContent('<div class="p-2 pr-5">' + content + '</div>');
    }

    function updatePosition(position) {
        var res = position.split(",");
        // eslint-disable-next-line no-undef
        var location = new google.maps.LatLng(res[0], res[1]);

        Global.MARKER.setPosition(location);

        // eslint-disable-next-line no-undef
        google.maps.event.trigger(Global.MAP, "resize");
        Global.MAP.panTo(Global.MARKER.getPosition());
        Global.MAP.setZoom(13);
    }
</script>

<style scoped>
    #map-responsive {
        overflow: hidden;
        position: relative;
        height: 0;
    }

    @media (max-width: 1360px) {
        #map-responsive {
            padding-bottom: 75%;
        }
    }
</style>